module.exports = __webpack_public_path__ + "img/safe-2-line.9bfe5f69.svg";